import { AddAlert } from '../../../../component';
import { loaded, loading } from '../../../../layout/redux/layoutActions';
import { buildCoordinates } from '../../../../shared/utils/map';
import {
  setMaxDate,
  setMaxUsefulArea,
  setMinDate,
  setMinUsefulArea,
} from '../../charts/redux/charts.actions';
import { setBigNumbers } from '../../bigNumbers/redux/bigNumbersActions';
import { setDisplayCharts, setMarketType } from '../../redux/dashboardActions';
import {
  setMarketCycleTimeframe,
  updateChartsDataMarketCycle,
  updateMarketCycleFiltersInputIntervals,
  updateRequestStatusMarketCycle,
} from './marketCycle.actions';
import {
  getBigNumbers,
  getRealEstateFinancingChart,
  getMarketCycleTimeframe,
  getReleasesINCC,
  getReleasesRealEstateFinancingChart,
  getReleasesVersusIPCA,
  getSecondaryINCC,
  getSelicChart,
} from './marketCycle.infra';

export const handlePriceInputs = (e, tuple) => {
  let name;
  let maskedValue = '';
  let newTuple = { min: '', max: '' };
  const replaceDots = e.value.replaceAll('.', '');
  const removeCurrencySymbol = replaceDots.split('R$');
  const hasCurrencySymbol = removeCurrencySymbol.length === 2;
  const valueAsFloat = hasCurrencySymbol
    ? parseInt(removeCurrencySymbol[1].trim())
    : parseInt(removeCurrencySymbol[0].trim());
  if (!Number.isNaN(valueAsFloat)) {
    maskedValue = valueAsFloat.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0,
    });
  }
  if (e.name.includes('min')) {
    newTuple = { min: maskedValue, max: tuple.max };
    name = e.name.split('min')[0];
  } else {
    newTuple = { min: tuple.min, max: maskedValue };
    name = e.name.split('max')[0];
  }
  const payload = {
    name,
    value: newTuple,
  };
  return (dispatch) => {
    dispatch(updateMarketCycleFiltersInputIntervals(payload));
  };
};

const isValidEventValue = (e) => {
  if (!Number.isNaN(parseInt(e.value)) && parseInt(e.value) < 0) return false;
  if (!e.value.match(/^(\d{0,3}\.*)+(,)?(\d{0,3})?$/) && e.value.length > 0)
    return false;
  return true;
};

const handleFloatInputs = (e) => {
  if (!Number.isNaN(e.value)) {
    return formatEventValue(e);
  }
  return '';
};

const handleIntegerInputs = (e) => {
  if (!Number.isNaN(parseInt(e.value))) {
    return parseInt(e.value);
  }
  return '';
};

const handleMin = (e, typeNumber) => {
  let min = 0;
  if (typeNumber === 'int') {
    min = handleIntegerInputs(e);
  } else {
    min = handleFloatInputs(e);
  }
  return min;
};

const handleMax = (e, typeNumber) => {
  let max = 0;
  if (typeNumber === 'int') {
    max = handleIntegerInputs(e);
  } else {
    max = handleFloatInputs(e);
  }
  return max;
};

const formatEventValue = (e) => {
  let formatted = e.value;
  const removeDots = e.value.replaceAll('.', '');
  const valueNotEndsInComma = removeDots[removeDots.length - 1] !== ',';
  if (valueNotEndsInComma) {
    const replaceCommas = removeDots.replaceAll(',', '.');
    formatted = new Intl.NumberFormat('pt-BR').format(replaceCommas);
  }
  if (formatted === '0') {
    formatted = '';
  }
  return formatted;
};

export const handleInputsIntervals = (e, tuple, typeNumber) => {
  return (dispatch) => {
    let name;
    let newTuple = { min: '', max: '' };
    if (!isValidEventValue(e, typeNumber)) return;
    if (e.name.includes('min')) {
      newTuple = { min: handleMin(e, typeNumber), max: tuple.max };
      name = e.name.split('min')[0];
    } else {
      newTuple = { min: tuple.min, max: handleMax(e, typeNumber) };
      name = e.name.split('max')[0];
    }
    const payload = {
      name,
      value: newTuple,
    };
    dispatch(updateMarketCycleFiltersInputIntervals(payload));
  };
};

export const searchMarketCycle = (payload) => (dispatch) => {
  if (payload?.inputIntervals?.timeframe) {
    dispatch([
      setMinDate(payload?.inputIntervals?.timeframe?.min),
      setMaxDate(payload?.inputIntervals?.timeframe?.max),
    ]);
  }
  if (payload?.inputIntervals?.privateAreaInterval) {
    dispatch([
      setMinUsefulArea(payload?.inputIntervals?.privateAreaInterval?.min),
      setMaxUsefulArea(payload?.inputIntervals?.privateAreaInterval?.max),
    ]);
  }
  const formattedPayload = payloadBuilder(payload);
  if (formattedPayload) {
    dispatch([
      loading(),
      generateBigNumbers(formattedPayload),
      generateMarketCycleCharts(formattedPayload),
    ]);
  } else {
    dispatch(AddAlert('warning', 'Selecione uma área no mapa'));
  }
};

const generateBigNumbers = (payload) => (dispatch) => {
  Promise.resolve(getBigNumbers(payload))
    .then((res) => {
      dispatch([setBigNumbers(res.data), setDisplayCharts('marketCycle')]);
    })
    .catch((err) => console.error(err))
    .finally((_) => dispatch(loaded()));
};

const generateMarketCycleCharts = (payload) => (dispatch) => {
  dispatch([
    setAllChartsLoading(),
    generateSelicChart(),
    generateRealEstateFinancingChart(),
    generateReleasesRealEstateFinancingChart(payload),
    generateReleasesVersusIPCA(payload),
    generateReleasesINCC(payload),
    generateSecondaryINCC(payload),
  ]);
};

const generateSelicChart = () => (dispatch) => {
  Promise.resolve(getSelicChart())
    .then((res) => {
      dispatch([
        updateChartsDataMarketCycle({ name: 'selicRate', value: res.data }),
        updateRequestStatusMarketCycle({ name: 'selicRate', value: 'LOADED' }),
      ]);
    })
    .catch((_) => {
      updateRequestStatusMarketCycle({ name: 'selicRate', value: 'FAILED' });
    });
};

const generateRealEstateFinancingChart = () => (dispatch) => {
  Promise.resolve(getRealEstateFinancingChart())
    .then((res) => {
      dispatch([
        updateChartsDataMarketCycle({
          name: 'realEstateFinancing',
          value: res.data,
        }),
        updateRequestStatusMarketCycle({
          name: 'realEstateFinancing',
          value: 'LOADED',
        }),
      ]);
    })
    .catch((_) => {
      dispatch(
        updateRequestStatusMarketCycle({
          name: 'realEstateFinancing',
          value: 'FAILED',
        })
      );
    });
};

const generateReleasesRealEstateFinancingChart = (payload) => (dispatch) => {
  Promise.resolve(getReleasesRealEstateFinancingChart(payload))
    .then((res) => {
      dispatch([
        updateChartsDataMarketCycle({
          name: 'releasesRealEstateFinancing',
          value: res.data,
        }),
        updateRequestStatusMarketCycle({
          name: 'releasesRealEstateFinancing',
          value: 'LOADED',
        }),
      ]);
    })
    .catch((_) => {
      dispatch(
        updateRequestStatusMarketCycle({
          name: 'releasesRealEstateFinancing',
          value: 'FAILED',
        })
      );
    });
};

const setAllChartsLoading = () => (dispatch) => {
  dispatch([
    updateRequestStatusMarketCycle({ name: 'selicRate', value: 'LOADING' }),
    updateRequestStatusMarketCycle({
      name: 'releasesINCC',
      value: 'LOADING',
    }),
    updateRequestStatusMarketCycle({
      name: 'secondaryINCC',
      value: 'LOADING',
    }),
    updateRequestStatusMarketCycle({
      name: 'releasesVersusIPCA',
      value: 'LOADING',
    }),
    updateRequestStatusMarketCycle({
      name: 'realEstateFinancing',
      value: 'LOADING',
    }),
    updateRequestStatusMarketCycle({
      name: 'releasesRealEstateFinancing',
      value: 'LOADING',
    }),
  ]);
};

const payloadBuilder = (data) => {
  const locationCoordinates = buildCoordinates();

  let location = {};

  if (locationCoordinates.radius) {
    location = {
      location: {
        coordinates: locationCoordinates?.coordinates,
        radius: locationCoordinates?.radius,
      },
    };
  } else {
    location = {
      location: {
        coordinates: locationCoordinates?.coordinates,
      },
    };
  }

  let inputIntervals = {};

  Object.keys(data.inputIntervals).map((el) => {
    const val = data.inputIntervals[el];
    if (val.min !== '' && val.max !== '') {
      let valor;
      const validateValue = {
        min: val.min,
        max: val.max,
      };
      if (val.min.includes('R$')) {
        validateValue.min = val.min.split('R$')[1].replaceAll('.', '');
      }
      if (val.max.includes('R$')) {
        validateValue.max = val.max.split('R$')[1].replaceAll('.', '');
      }
      valor =
        el === 'timeframe'
          ? { min: val.min, max: val.max }
          : { min: Number(validateValue.min), max: Number(validateValue.max) };
      inputIntervals = { ...inputIntervals, [el]: valor };
    }
  });
  const newData = {
    ...data,
    inputIntervals,
  };
  if (!location) {
    return null;
  } else {
    const bedrooms = newData.bedrooms
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const suites = newData.suites
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const garages = newData.garages
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const payload = {
      ...location,
      ...newData,
      bedrooms,
      suites,
      garages,
    };
    return payload;
  }
};

export const generateMarketCycleList = () => (dispatch) => {
  const timeframe = JSON.parse(
    localStorage.getItem('LaunchingYearsMarketCycle')
  );
  if (timeframe) {
    dispatch(setMarketCycleTimeframe(timeframe));
  } else {
    Promise.resolve(getMarketCycleTimeframe())
      .then((res) => {
        const launchingYears = res.data.launching_years;
        localStorage.setItem(
          'LaunchingYearsMarketCycle',
          JSON.stringify(launchingYears)
        );
        dispatch(setMarketCycleTimeframe(launchingYears));
      })
      .catch((err) => {
        dispatch(AddAlert('error', 'Erro ao carregar intervalo de tempo'));
      });
  }
};

export const generateReleasesVersusIPCA = (payload) => (dispatch) => {
  Promise.resolve(getReleasesVersusIPCA(payload))
    .then((res) => {
      dispatch([
        updateChartsDataMarketCycle({
          name: 'releasesVersusIPCA',
          value: res.data,
        }),
        updateRequestStatusMarketCycle({
          name: 'releasesVersusIPCA',
          value: 'LOADED',
        }),
      ]);
    })
    .catch((_) =>
      dispatch(
        updateRequestStatusMarketCycle({
          name: 'releasesVersusIPCA',
          value: 'FAILED',
        })
      )
    );
};

export const generateReleasesINCC = (payload) => (dispatch) => {
  Promise.resolve(getReleasesINCC(payload))
    .then((res) => {
      dispatch([
        updateChartsDataMarketCycle({ name: 'releasesINCC', value: res.data }),
        updateRequestStatusMarketCycle({
          name: 'releasesINCC',
          value: 'LOADED',
        }),
      ]);
    })
    .catch((_) => {
      dispatch(
        updateRequestStatusMarketCycle({
          name: 'releasesINCC',
          value: 'FAILED',
        })
      );
    });
};

export const generateSecondaryINCC = (payload) => (dispatch) => {
  Promise.resolve(getSecondaryINCC(payload))
    .then((res) => {
      dispatch([
        updateChartsDataMarketCycle({ name: 'secondaryINCC', value: res.data }),
        updateRequestStatusMarketCycle({
          name: 'secondaryINCC',
          value: 'LOADED',
        }),
      ]);
    })
    .catch((_) => {
      dispatch(
        updateRequestStatusMarketCycle({
          name: 'secondaryINCC',
          value: 'FAILED',
        })
      );
    });
};
